import { Button, Dialog, IDialogProps, Intent } from '@blueprintjs/core'
import { AxiosError } from 'axios'
import * as React from 'react'
import Client from '../../../../../../client'
import APIErrorCallout from '../../../../../../components/errors/APIErrorCallout'
import { APISelect } from '../../../../../../components/selects/APISelect'
import { showSuccess } from '../../../../../../Toast'

interface Props extends IDialogProps {
  productId: number
  marketAccountIds?: number[]
  currentStrategyId?: number
  onChangeSuccess?: () => void
}

export const ChangeStrategyDialog: React.FC<Props> = props => {
  const [selectedStrategyId, setSelectedStrategyId] = React.useState(props.currentStrategyId)
  const [loading, setLoading] = React.useState(false)
  const [error, setError] = React.useState<AxiosError>(undefined)

  async function onSubmit() {
    setLoading(true)
    setError(undefined)
    try {
      await Client.v5ProductChangeStrategy(props.productId, { id: selectedStrategyId })
      props.onChangeSuccess()
      showSuccess('Successfully changed strategy')
    } catch (e) {
      setError(e)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Dialog title="Select a strategy" {...props}>
      <div className="bp3-dialog-body">
        {error && <APIErrorCallout response={error.response} />}
        <APISelect
          request={() => Client.getListingStrategies({ marketAccountIds: props.marketAccountIds })}
          value={selectedStrategyId}
          onChange={e => setSelectedStrategyId(+e.target.value)}
          onReceiveData={data => setSelectedStrategyId(data?.listingStrategies && data?.listingStrategies[0].id)}
          process={data =>
            data.listingStrategies
              .map(strategy => ({ label: strategy.name, value: strategy.id }))
              .sort((a, b) => a.label.localeCompare(b.label))
          }
          fill
        />
      </div>
      <div className="bp3-dialog-footer">
        <div className="bp3-dialog-footer-actions">
          <Button minimal text="Cancel" onClick={props.onClose} />
          <Button loading={loading} intent={Intent.PRIMARY} text="Apply this strategy" onClick={onSubmit} />
        </div>
      </div>
    </Dialog>
  )
}
